
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import PopularCard from "../../components/Cards/PopularCard";
import { collection, getDocs } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import ClientForm from "../../components/ClientForm/ClientForm";
import { Helmet } from "react-helmet-async";

const Tours = () => {
  const [tours, setTours] = useState([]);
  const [states, setStates] = useState([]);
  const navigate = useNavigate();

  const getTours = async () => {
    const snapshot = await getDocs(collection(fireDB, "tours"));
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setTours(data);

    // Get unique states from tours
    const uniqueStates = [...new Set(data.map((tour) => tour.state))];
    setStates(uniqueStates);
  };

  useEffect(() => {
    getTours();
    document.title = "Tours";
    window.scrollTo(0, 0);
  }, []);
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "TravelAgency",
        "name": "Shivay Tour and Travells",
        "url": "https://www.shivaytourandtravells.com/",
        "@id": "https://www.shivaytourandtravells.com/#organization",
        "logo": "https://www.shivaytourandtravells.com/logo.png"
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.shivaytourandtravells.com/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Tours"
          }
        ]
      },
      ...tours.map((tour, index) => ({
        "@type": "Product",
        "name": tour.title,
        "image": tour.image || tour.imageUrl || "",
        "description": tour.description || "",
        "sku": tour.id,
        "brand": {
          "@type": "Brand",
          "name": "Shivay Tour and Travells"
        },
        "offers": {
          "@type": "Offer",
          "url": `https://www.shivaytourandtravells.com/tours/${tour.id}`,
          "priceCurrency": "INR",
          "price": tour.price || "N/A",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": tour.rating || "5.0",
          "reviewCount": tour.reviews || "0"
        }
      }))
    ]
  };
  return (
    <>
      <Helmet>
        <title>Tours | Shivay Tour & Travells</title>
        <meta
          name="description"
          content="Browse all our tour packages. Explore Gujarat and India with Shivay Tour & Travells for unforgettable, budget-friendly trips."
        />
        <meta
          name="keywords"
          content="tour packages, Gujarat tours, India travel packages"
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Helmet>

      <Breadcrumbs title="Tours" pagename="Tours" />

      {/* State Filter Buttons */}
      <section className="py-4 bg-light">
        <Container>
          <h4 className="mb-3 fw-bold text-primary">Filter by State</h4>
          <div className="d-flex flex-wrap gap-3">
            {states.map((state, i) => (
              <Button
                key={i}
                variant="outline-primary"
                onClick={() => navigate(`/state/${state}`)}
              >
                {state}
              </Button>
            ))}
          </div>
        </Container>
      </section>

      {/* All Tours */}
      <section className="py-5 tour_list">
        <Container>
          <Row>
            {tours.length > 0 ? (
              tours.map((val) => (
                <Col xl={4} md={6} sm={6} xs={12} className="mb-4" key={val.id}>
                  <PopularCard val={val} />
                </Col>
              ))
            ) : (
              <Col>
                <p className="text-center">No tours found.</p>
              </Col>
            )}
          </Row>
        </Container>
      </section>

      <ClientForm />
    </>
  );
};

export default Tours;
